module.exports = __webpack_public_path__ + "static/media/Sunny soffa 3-sits XL tyg orinocco grey detalj grey 2023 2.9c0c2e9a.jpg";